import type { Plugin } from '@elizaos/core';
import { getPortfolioAction } from './actions/getPortfolio';
import { getTokenPriceDataAction } from './actions/getTokenPriceData';
import { getNFTCollectionAction } from './actions/getNFTCollection';
import { getTransactionHistoryAction } from './actions/getTransactionHistory';
import { getTransactionDetailsAction } from './actions/getTransactionDetails';
import { getAccountInfoAction } from './actions/getAccountInfo';
import { getAppPositionsAction } from './actions/getAppPositions';
import { getCrossChainAssetsAction } from './actions/getCrossChainAssets';
import { portfolioProvider } from './providers/portfolioProvider';
import { transactionProvider } from './providers/transactionProvider';
import { accountProvider } from './providers/accountProvider';
import { defiProvider } from './providers/defiProvider';
import { marketDataProvider } from './providers/marketDataProvider';

export const zapperPlugin: Plugin = {
  name: 'zapper',
  description:
    'Zapper protocol integration plugin for portfolio tracking, DeFi analytics, and blockchain data across 50+ networks',
  actions: [
    getPortfolioAction,
    getTokenPriceDataAction,
    getNFTCollectionAction,
    getTransactionHistoryAction,
    getTransactionDetailsAction,
    getAccountInfoAction,
    getAppPositionsAction,
    getCrossChainAssetsAction,
  ],
  providers: [
    portfolioProvider,
    transactionProvider,
    accountProvider,
    defiProvider,
    marketDataProvider,
  ],
};

export default zapperPlugin;

// Export types for external use
export * from './types';
export {
  getPortfolioAction,
  getTokenPriceDataAction,
  getNFTCollectionAction,
  getTransactionHistoryAction,
  getTransactionDetailsAction,
  getAccountInfoAction,
  getAppPositionsAction,
  getCrossChainAssetsAction,
};
export {
  portfolioProvider,
  transactionProvider,
  accountProvider,
  defiProvider,
  marketDataProvider,
};
